webpackJsonp([1],[
/* 0 */
/*!************************!*\
  !*** multi ./index.js ***!
  \************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /opt/build/repo/examples/insertComponent/index.js */1);


/***/ }),
/* 1 */
/*!******************!*\
  !*** ./index.js ***!
  \******************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kokk__ = __webpack_require__(/*! kokk */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_kokk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_kokk__);


var doc = new __WEBPACK_IMPORTED_MODULE_0_kokk___default.a({
  root: 'https://raw.githubusercontent.com/luyilin/kokk/master/',
  titleClassname: 'title'
});

doc.addComponent({
  order: 4,
  component: function component() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, /*! ./components/Demo.vue */ 3));
  },
  showExpandIcon: true
});

/* harmony default export */ __webpack_exports__["default"] = (doc.start('#app'));

/***/ })
],[0]);


// WEBPACK FOOTER //
// client.a79332c6.js